// removed by extract-text-webpack-plugin
module.exports = {"root":"_1AN0FvrGU_nyP9QW9QFXWS_0","rotated":"zIrdSmQsCxOLYrgfBTjL-_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-534a6a53","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/RotatedHeading.vue
// module id = 5CVA
// module chunks = 15 16 17 18